import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor() {}

  isIOS() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform,
    )
  }

  isSafari() {
    if (!this.isIOS()) {
      return false
    }

    return /Safari/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent)
  }

  isChromeIOS() {
    if (!this.isIOS()) {
      return false
    }

    return /CriOS/.test(navigator.userAgent)
  }

  isNotSafariOrChromeIOS() {
    return !this.isSafari() && !this.isChromeIOS()
  }

  isAndroid() {
    return /Android/i.test(navigator.userAgent)
  }

  isRunningAsPWA() {
    return this.isPWA()
  }

  isPWA() {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true
    return isStandalone || document.referrer.includes('android-app://')
  }

  hasServiceWorker() {
    return navigator.serviceWorker && navigator.serviceWorker.controller ? true : false
  }
}
